var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBulletList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 .83C1.038.83.25 1.604.25 2.571c0 .968.788 1.744 1.75 1.744s1.75-.776 1.75-1.744C3.75 1.605 2.962.83 2 .83zM2 6.788c-.962 0-1.75.775-1.75 1.743 0 .968.788 1.743 1.75 1.743S3.75 9.5 3.75 8.531c0-.968-.788-1.743-1.75-1.743zM2 12.747c-.962 0-1.75.775-1.75 1.743 0 .967.788 1.743 1.75 1.743s1.75-.776 1.75-1.743c0-.968-.788-1.743-1.75-1.743zM5.75 3.069a.75.75 0 01.75-.75h8a.75.75 0 010 1.5h-8a.75.75 0 01-.75-.75zM5.75 9.028a.75.75 0 01.75-.75h8a.75.75 0 010 1.5h-8a.75.75 0 01-.75-.75zM5.75 14.986a.75.75 0 01.75-.75h8a.75.75 0 010 1.5h-8a.75.75 0 01-.75-.75z",
    fill: "#928E9E"
  })));
}

export default SvgBulletList;